import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaStar, FaSpinner } from 'react-icons/fa';
import styles from './ProductReviewsRatings.module.css';

const ProductReviewsRatings = () => {
    const [loading, setLoading] = useState(true);

    const reviewsData = {
        ratings: 9873,
        reviews: 1224,
        fiveStar: 4914,
        fourStar: 2453,
        threeStar: 1064,
        twoStar: 368,
        oneStar: 1074,
        qualityRating: 3.4,
        designRating: 3.7,
        valueRating: 3.7,
        deliveryRating: 3.8,
        reviewList: [
            {
                rating: 4,
                text: 'Pretty good. Product is very delicate, if you have children, better don’t go for it.',
                author: 'Naga Raj',
                location: 'Navi Mumbai',
                date: 'Nov, 2018',
            },
            {
                rating: 5,
                text: 'Terrific. Very nice!',
                author: 'Md Irfan Khan',
                location: 'Rajahmundry',
                date: 'Jun, 2019',
            },
            {
                rating: 4,
                text: 'Worth the money. Good, ok.',
                author: 'Shamila Sulaiman',
                location: 'Pallippuram, Thiruvananthapuram District',
                date: 'Aug, 2019',
            },
        ],
    };

    useEffect(() => {
        setTimeout(() => setLoading(false), 1500); // Simulating loading time
    }, []);

    if (loading) {
        return (
            <div className={styles.spinnerContainer}>
                <FaSpinner className={styles.spinner} />
            </div>
        );
    }

    if (!reviewsData) {
        return <p className={styles.error}>No review data available.</p>;
    }

    const {
        ratings = 0,
        reviews: totalReviews = 0, // Renamed to avoid conflict with reviews array
        fiveStar = 0,
        fourStar = 0,
        threeStar = 0,
        twoStar = 0,
        oneStar = 0,
        qualityRating = 0,
        reviewList = [], // Renamed array for clarity
    } = reviewsData;

    const starCounts = [fiveStar, fourStar, threeStar, twoStar, oneStar];
    const totalRatings = ratings || 1; // Prevent division by zero

    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>Ratings & Reviews</h2>

            <div className={styles.ratingSummary}>
                <div className={styles.ratingStars}>
                    {[...Array(5)].map((_, index) => (
                        <FaStar
                            key={index}
                            className={index < Math.round(qualityRating) ? styles.filledStar : styles.emptyStar}
                        />
                    ))}
                </div>
                <motion.div
                    className={styles.ratingDetails}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    <span className={styles.ratingNumber}>{ratings} Ratings &</span>
                    <span className={styles.reviewNumber}>{totalReviews} Reviews</span>
                </motion.div>
            </div>

            <div className={styles.barContainer}>
                {['5★', '4★', '3★', '2★', '1★'].map((rating, index) => {
                    const total = starCounts[index];
                    const percentage = (total / totalRatings) * 100;
                    return (
                        <div key={index} className={styles.barRow}>
                            <div className={styles.barLabel}>{rating}</div>
                            <motion.div
                                className={styles.bar}
                                style={{ width: `${percentage}%` }}
                                initial={{ width: 0 }}
                                animate={{ width: `${percentage}%` }}
                                transition={{ duration: 1 }}
                            ></motion.div>
                        </div>
                    );
                })}
            </div>

            <h3 className={styles.reviewsHeading}>Customer Reviews</h3>
            <div className={styles.reviewsList}>
                {reviewList.length > 0 ? (
                    reviewList.map((review, index) => (
                        <div key={index} className={styles.reviewCard}>
                            <div className={styles.reviewHeader}>
                                <div className={styles.reviewRating}>
                                    {[...Array(review.rating)].map((_, i) => (
                                        <FaStar key={i} className={styles.filledStar} />
                                    ))}
                                </div>
                                <div className={styles.reviewDetails}>
                                    <span className={styles.reviewAuthor}>{review.author || 'Anonymous'}</span>
                                    <span className={styles.reviewLocation}>{review.location || 'Unknown'}</span>
                                    <span className={styles.reviewDate}>{review.date || 'N/A'}</span>
                                </div>
                            </div>
                            <p className={styles.reviewText}>{review.text || 'No review text provided.'}</p>
                        </div>
                    ))
                ) : (
                    <p>No reviews available.</p>
                )}
            </div>
        </div>
    );
};

export default ProductReviewsRatings;
